module.exports = __webpack_public_path__ + "img/PaymentCN.1f2537a6.png";